import React from 'react';
import { TermsAndConditionsModalButton } from '../app/TermsAndConditions';


interface Props {
  text: string
  portalSlug: string
}

export const TextWithTermsLinks = (props: Props) => {
  const pieces = getPieces(props.text, props.portalSlug, 'terms and conditions');
  return <>{pieces}</>;
}

const getPieces = (text: string, portalSlug: string, termsText: string) => {
  let remaining = text;
  const pieces = [];
  let key = 0;
  while (remaining.length > 0) {
    let i = remaining.toLowerCase().indexOf(termsText);
    if (i === -1) {
      pieces.push(<React.Fragment key={key++}>{remaining}</React.Fragment>)
      remaining = ''
    }
    else {
      pieces.push(<React.Fragment key={key++}>{remaining.substring(0, i)}</React.Fragment>)
      pieces.push(
        <TermsAndConditionsModalButton key={key++} className="btn btn-link p-0 d-inline border-0" portalSlug={portalSlug}>
          {remaining.substring(i, i + termsText.length)}
        </TermsAndConditionsModalButton>
      )
      remaining = remaining.substring(i + termsText.length)
    }
  }
  return pieces;
}